import { render } from "./DefecationModal.vue?vue&type=template&id=07c9480a&scoped=true&ts=true"
import script from "./DefecationModal.vue?vue&type=script&lang=ts"
export * from "./DefecationModal.vue?vue&type=script&lang=ts"

import "./DefecationModal.vue?vue&type=style&index=0&id=07c9480a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c9480a"]])

export default __exports__